import React, { createContext, useContext } from 'react'

/**
 * Context for providing translated block content to all components.
 * Translation happens automatically in wrapPageElement, making it
 * invisible to page authors.
 */
const TranslatedBlockContentContext = createContext({})

/**
 * Provider component for translated block content.
 * Used internally by wrapPageElement.
 */
export const TranslatedBlockContentProvider = ({ value, children }) => {
    return (
        <TranslatedBlockContentContext.Provider value={value}>
            {children}
        </TranslatedBlockContentContext.Provider>
    )
}

/**
 * Hook to access translated block content.
 *
 * Usage in pages:
 * ```jsx
 * const content = useBlockContent()
 * return <Hero content={content.hero} />
 * ```
 *
 * @returns {Object} Translated content keyed by block identifier
 */
export const useBlockContent = () => {
    return useContext(TranslatedBlockContentContext)
}

export default TranslatedBlockContentContext